const businessTypeList = [
  'Toutes catégories confondues',
  'Ateliers de mécanique',
  'Autre',
  'Bijouteries',
  'Boutiques de cadeaux',
  'Hébergement',
  'Immobilier',
  'Juridique',
  'Boîtes de nuit',
  'Opticiens',
  'Prêt-à-porter',
  'Ressources humaines',
  'Agences de voyage',
  'Agriculture',
  'Alimentation générale',
  'Arts de la scènes, événementiel',
  'Ateliers de création',
  'Beauté',
  'Blanchisseries et couture',
  'Bâtiment',
  'Cafés et restaurants',
  'Commerces divers',
  'Communication',
  'Consultants, conseillers',
  'Cordonniers',
  'Épicerie',
  'Fiduciaires, finances',
  'Fleuristes',
  'Formation',
  'Garages',
  'Import-export',
  'Imprimeries',
  'Informatique',
  'Ingénieurs',
  'Kiosques',
  'Librairies',
  'Menuiseries',
  'Nettoyage',
  'Jardinage, paysagisme',
  'Sanitaires, chauffage, etc.',
  'Santé',
  'Magasins de sport',
  'Sécurité ',
  'Tatoueurs',
  'Transport',
  'Édition',
  'Électricité'
]

export default businessTypeList
